import { SaveFilled, SaveOutlined } from "@ant-design/icons";
import { ButtonProps } from "antd";
import { XmButton } from "../button/XmButton";

interface XmSaveButtonProps extends ButtonProps {
  isTouched: boolean
}

function XmSaveButton({ isTouched, ...rest }: XmSaveButtonProps) {

  return <XmButton
    {...rest}
    icon={isTouched ? <SaveFilled style={{ color: '#b22222' }} /> : <SaveOutlined />}
  />;
}

export default XmSaveButton;